<template>
  <v-container grid-list-md v-if="this.$store.getters.programsFetched">
    <v-layout row>
      <v-flex xs6>
        <h1>Registrations</h1>
      </v-flex>
      <v-flex xs2 class="text-xs-right">
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            @click="getRegistrations()"
            icon
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-data-table
          :headers="headers"
          :search="search"
          :items="registrations"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.expirationDate }}</td>
            <td class="text-xs-right">
                <v-menu offset-y open-on-hover>
                  <template slot="activator">
                    <v-btn small fab>
                      <v-icon>list</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile>
                      <v-btn flat small round
                             @click="resendEmail(props.item)">
                        Resend Email
                      </v-btn>
                    </v-list-tile>

                    <v-list-tile>
                      <br>
                      <v-btn flat small round
                             @click="extendExpiration(props.item)">
                        Extend Expiration
                      </v-btn>
                    </v-list-tile>

                  </v-list>
                </v-menu>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true"  type="info" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../../main.js'

export default {
  data: () => ({
    search: '',
    registrations: [],
    headers: [
      {text: 'Email',  align: 'left', value: 'email'},
      {text: 'Expiration Date',  align: 'left', value: 'expirationDate'},
      {text: '', value: ''}
    ],
    dealerName: '',
    doingBusinessAs: ''
  }),
  methods: {
    resendEmail(registration) {
      if (!confirm('Are you sure you want to resend an email to ' + registration.email)) return;

      //this just does the same thing as using the account register page
      let request = {
        "email" : registration.email,
        "domain" : this.$store.getters.getDomain
      }

      axiosAuthInstance
        .post('api/v1/pub/participant/requestAccount', request)
        .then(response => {
          this.notifyInfo('Email sent')
        })
        .catch(error => {
          this.notifyAxiosError(
            error, 'There was an error resending the email'
          )
        })
    },
    extendExpiration(registration) {
      axiosAuthInstance
        .post('api/v1/admin/user/extendExpiration/', registration)
        .then(response => {
          this.getRegistrations()
        })
        .catch(error => {
          this.notifyAxiosError(
            error, 'There was an error extending the expiration'
          )
        })
    },
    getRegistrations() {
      this.loading = true
      axiosAuthInstance
        .get('api/v1/admin/user/registrations/' + this.$store.getters.getDomain)
        .then(response => {
          if (response.data) {
            this.registrations = response.data
          }
        })
        .catch(error => {
          if (error.response && error.response.status == '401') {
            this.$router.push({
              path: '/login'
            })
          } else {
            this.notifyAxiosError(
              error,
              'There was an error fetching registrations'
            )
          }
        })
        .then(() => {
          this.loading = false
        })
    }
  },
  mounted() {
    this.getRegistrations()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Registrations.vue